import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import {
  CHANGE_PASSWORD_TRANSLATION_NAMESPACE,
  STATUS_ERROR, STATUS_IDLE,
  STATUS_SUCCESS,
} from 'consts';
import { EnelXGuiAtoms } from 'gui';
import useForm from 'hook/useForm';
import useValidator from 'hook/useValidator';
import changePasswordSchema from 'schema/changePassword-schema';
import { useTheme } from 'styled-components';
import { copy, isItEmpty, setValue } from 'utils';

// import { t } from 'i18n_new';
import ErrorPassword from './components/ErrorPassword';
import FormPassword from './components/FormPassword';
import SuccessPassword from './components/SuccessPassword';
import { ChangePasswordWrapper } from './styles';

const { ImageLogo, Row, MigrationIcon } = EnelXGuiAtoms;

const INITIAL_UTILITY = {
  isPswVisible: false,
  isPswCheckVisible: false,
  pswStatus: STATUS_IDLE,
};

const ChangePassword = () => {
  const history = useHistory();
  const theme = useTheme();
  const { isPassword } = useValidator();
  const { t } = useTranslation(CHANGE_PASSWORD_TRANSLATION_NAMESPACE);
  const [utility, setUtility] = useState(INITIAL_UTILITY);
  const pswSchema = changePasswordSchema(isPassword);

  const {
    data: formData,
    errors: errorFields,
    handleChange,
    isValid,
    resetToInitial,
  } = useForm({}, {
    defaultIsValid: false,
    schema: pswSchema,
    validationGuard: (_eFields, data) => !isItEmpty(data),
  });

  const handleUtility = (key, value) => {
    const newUtility = copy(utility);
    setValue(newUtility, key, value);
    setUtility(newUtility);
  };

  const toShow = [
    {
      component(key) {
        return (
          <FormPassword
            errorFields={errorFields}
            formData={formData}
            handleChange={handleChange}
            handleUtility={handleUtility}
            isFormValid={isValid}
            key={key}
            utility={utility}
          />
        );
      },
      condition: STATUS_IDLE,
    },
    {
      component(key) {
        return (<SuccessPassword key={key} />);
      },
      condition: STATUS_SUCCESS,
    },
    {
      component(key) {
        return (<ErrorPassword handleUtility={handleUtility} resetToInitial={resetToInitial} key={key} />);
      },
      condition: STATUS_ERROR,
    },
  ];

  useEffect(() => {
    ['pollingDashboard', 'pollingStationDetails', 'onDashboard'].forEach((key) => localStorage.removeItem(key));
  }, []);

  return (
    <ChangePasswordWrapper>
      <div className="changePassword-wrapper">
        {/** CHANGE PSW HEADER LOGO */}
        {theme?.config?.changePasswordLogo ? (
          <div className="enelLogo">
            <Row>
              <ImageLogo
                alt="change_psw_logo"
                source={theme.config.changePasswordLogo}
              />
            </Row>
          </div>
        ) : null}
        <div
          className="backsign"
          onClick={() => {
            history.goBack();
            handleUtility('isPswOnError', false);
          }}
          role="presentation"
        >
          <MigrationIcon
            library="material"
            name="arrow_back"
            size="25px"
          />
          <span>{t('back')}</span>
        </div>
        <div className="container-wrapper">
          {
            toShow.map(({ component, condition }, index) => (utility.pswStatus === condition ? component(index) : null))
          }
        </div>
      </div>
    </ChangePasswordWrapper>
  );
};

export default ChangePassword;
